<template>
  <a-form-item class="phoneInput">
    <a-input
      ref="input"
      :placeholder="placeholder || $t('user.login.name.placeholder')"
      v-decorator="[
        'phoneNumber',
        {
          rules: [
            {
              validator: checkPhoneNumberOrEmail,
            },
          ],
          normalize: function(value) {
            return value ? value.trim() : value;
          },
        },
      ]"
    >
      <icon-font slot="prefix" type="mobile" />
    </a-input>
  </a-form-item>
</template>

<script>
/** 手机号或邮箱输入框 */
import { validatePhoneReg, validateEmailReg } from "@/utils/validator";
import IconFont from "@/components/IconFont";

export default {
  components: {
    IconFont,
  },
  props: {
    placeholder: {
      default: "",
    },
  },
  mounted() {
    this.$refs.input.focus();
  },
  methods: {
    checkPhoneNumberOrEmail(rule, value, callback) {
      if (validatePhoneReg.test(value) || validateEmailReg.test(value)) {
        callback();
      }
      callback(new Error(this.$t("user.name.error")));
    },
  },
};
</script>
